export default __webpack_public_path__ + "static/spend-balance-screen-956327017266199db6e7b66c62b880f4.png";